import httpClient from '@/services/http/httpClient.ts'
import type { LoginResponse } from '@/services/http/httpResponses.ts'

class AuthHttpService {
  public login(username: string, password: string) {
    return httpClient.post<LoginResponse>(
      '/api/connect/token',
      {
        grant_type: 'password',
        username: username,
        password: password,
        client_id: 'spa_app',
        scope: 'offline_access',
      },
      {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      },
    )
  }
  public logout() {
    return httpClient.get('/api/connect/logout')
  }
}

export default new AuthHttpService()
